import request from "./axios";

function setupAccounts(params) {
  return request({
    method: "post",
    url: `/coaching/setup_accounts`,
    data: params
  })
}

const CoachingPortalService = {
  setupAccounts
};

export default CoachingPortalService;
